import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function ConfirmationDateDeReunionPlastitoc({
  variablesData,
}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Bonjour,</p>
      <p>
        J'accuse réception de votre devis concernant la livraison de notre
        commande de produits référencés 6430 B et 5320 G.
      </p>
      <p>
        Je vous confirme la date de notre rendez-vous dans nos bureaux le{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.plastitoc_rdv_date) || 0,
        )}{" "}
        à 9h00 afin d'évoquer les modalités de notre contrat de vente qui je
        vous le rappelle devrait se monter approximativement à 230 000 € HT.
      </p>
      <p>
        Je vous prie de croire, Monsieur, à l'expression de mes salutations
        distinguées.
      </p>
      <MailSignature
        emetteurLogo={ConfirmationDateDeReunionPlastitoc.metadata.emetteurLogo}
        emetteur={ConfirmationDateDeReunionPlastitoc.metadata.emetteur}
        emetteurPoste={
          ConfirmationDateDeReunionPlastitoc.metadata.emetteurPoste
        }
        emetteurEntreprise={
          ConfirmationDateDeReunionPlastitoc.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

ConfirmationDateDeReunionPlastitoc.metadata = {
  titre: "Confirmation date de réunion Plastitoc",
  cleMail: "confirmation_date_de_reunion_Plastitoc",
  messageTransfert: false,
  emetteur: "Jean Bertrand",
  emetteurPoste: "Directeur Général",
  emetteurEntreprise: "PLASTITOC",
  emetteurLogo: "/logos/plastitoc.png",
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default ConfirmationDateDeReunionPlastitoc;
